import axios from 'axios';
import { z } from 'zod';

const outOfScopeBody = z.object({
  code: z.literal('bound_list_out_of_scope'),
  lists: z.array(z.object({ name: z.string() })).min(1),
});

/** The lists a draft save was refused for linking outside the schema's scope, if that was why. */
export function outOfScopeListNames(error: unknown): string[] | undefined {
  if (!axios.isAxiosError(error)) return undefined;
  const parsed = outOfScopeBody.safeParse(error.response?.data);
  return parsed.success ? parsed.data.lists.map((l) => l.name) : undefined;
}
